import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { decodeToken } from '../../lib/jwt';

// Roles permitted to access the admin area. Must mirror the backend's
// ADMIN_ROLES in src/middleware/adminMiddleware.bun.ts.
const ADMIN_ROLES = ['owner', 'admin'];

const AdminProtectedRoute: React.FC = () => {
  const location = useLocation();
  const authToken = localStorage.getItem('authToken');

  // Not logged in at all — send to login.
  if (!authToken) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Gate the UI on the role embedded in the token. This is a convenience check
  // only; the backend independently enforces the role on every admin API call.
  // NOTE: the role here reflects the token issued at login. If a user's role is
  // changed in the database, they must log out and back in for this guard to see
  // the new role.
  const role = decodeToken(authToken)?.role;

  if (!role || !ADMIN_ROLES.includes(role)) {
    return (
      <Navigate
        to="/dashboard"
        state={{ message: 'Access denied: admin role required.' }}
        replace
      />
    );
  }

  return <Outlet />;
};

export default AdminProtectedRoute;
